export default "__VITE_ASSET__Dvz4Pr2C__"